import { FC } from 'react';

export type FieldTitleIwProps = {
  label: string;
  required?: boolean;
};

export const FieldTitleIw: FC<FieldTitleIwProps> = ({ label, required }) => {
  return (
    <span>
      {label} {required && '*'}
    </span>
  );
};
